import { environments } from './Constants'

/**
 * True when the user holds at least one of `required`.
 *
 * No requirement (missing or empty) means anyone signed in. A user with no
 * permissions list holds nothing, so any requirement fails: fail closed.
 * Used by both the sidebar and the route guard so the two always agree.
 *
 * @param {string[]|undefined} userPermissions  from the auth cookie
 * @param {string[]|undefined} required         a ROLE_SETS entry
 * @returns {boolean}
 */
export const hasAnyRole = (userPermissions, required) => {
    if (!required || required.length === 0) return true
    if (!Array.isArray(userPermissions)) return false
    return userPermissions.some((p) => required.includes(p))
}

/**
 * The role that may change what other people's sends depend on (delete a
 * template, mark one approved or inactive, change holidays) on this host, as
 * in the applause app: comms-tool-dev on dev, comms-tool-prod on production,
 * none elsewhere.
 *
 * @param {object} env  getEnvironmentVariables()
 */
export const commsManagerRole = (env) => {
    if (env?.domain === environments.dev.domain) return 'comms-tool-dev'
    if (env?.domain === environments.prod.domain) return 'comms-tool-prod'
    return null
}

/** True when `permissions` hold this host's commsManagerRole. */
export const canManageComms = (permissions, env) => {
    const role = commsManagerRole(env)
    return !!role && Array.isArray(permissions) && permissions.includes(role)
}
